/** 臻有钱-分期商城协议页-审核结果页-曝光 - expose */
export const shopMallAgreementResultExpose = 'finance_loan_shopMall_agreement_result_expose';

/** 臻有钱-分期商城协议页-审核结果页-点击 - click */
export const shopMallAgreementResultClick = 'finance_loan_shopMall_agreement_result_click';
